import { hexToRgba } from '../../../../utils/hexToRgba';

const DEFAULT_RGBA = { r: 255, g: 255, b: 255, a: 0 };

export function getHexaSwatchColor(color: string) {
  const { r, g, b, a } = hexToRgba(color) ?? DEFAULT_RGBA;

  const solidColor = `rgba(${r}, ${g}, ${b}, 1)`;
  const transparentColor = `rgba(${r}, ${g}, ${b}, ${a})`;

  return { opacity: a, colorString: `linear-gradient(to right, ${solidColor} 50%, ${transparentColor} 50%)` };
}
